import React from "react";
import Hero from "@/components/Hero";
import TrustStrip from "@/components/TrustStrip";
import Newsletter from "@/components/Newsletter";
import Seo from "@/components/Seo";
import { TrustLine, ShopByCategory, FeaturedProducts, ResearchTrio } from "@/components/HomeSections";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Seo
        title="Reference-Grade Research Compounds"
        description="Molecularix Biolabs supplies reference-grade peptides and research chemicals for in-vitro laboratory research, with clear specifications and documentation. For research use only."
        path="/"
      />
      <Hero />
      <TrustLine />
      <ShopByCategory />
      <FeaturedProducts />
      <TrustStrip />
      <ResearchTrio />
      <Newsletter />
    </main>
  );
}
